import React from "react";
import TermOfUseLayout from "../../../components/TermOfUseLayout";
import s from "../../../styles/PolicyLayout.module.css";

export default function PupverseTerms() {
  return (
    <TermOfUseLayout
      title="terms of use"
      appName="Pupverse: Dog Training"
      date="SEPTEMBER 2025"
    >
      <div className={s.title}>1) Acceptance of Terms</div>
      <p>
        These Terms of Use govern your access to and use of the Pupverse: Dog
        Training mobile
        application ("Application"), provided by Aleksandra Scherbachenko
        ("Service Provider"). By downloading, installing, or using the
        Application, you agree to these Terms.
      </p>

      <div className={s.title}>2) Nature of the Service</div>
      <p>
        The Application is provided as a free service on an "AS IS" basis. The
        Service Provider may update, modify, suspend, or discontinue parts of
        the service at any time.
      </p>

      <div className={s.title}>3) Eligibility and User Responsibility</div>
      <p>
        You are responsible for using the Application in compliance with
        applicable laws and platform rules. You must provide accurate
        information when submitting requests or communicating through support.
      </p>

      <div className={s.title}>4) Data and Permissions</div>
      <p>
        Use of the Application may require access to data such as device
        information, approximate location, and photos. By continuing to use the
        Application, you acknowledge and agree to the related processing as
        described in the Privacy Policy.
      </p>

      <div className={s.title}>5) Prohibited Use</div>
      <p>You agree not to:</p>
      <ul>
        <li>Use the Application for unlawful, abusive, or fraudulent purposes.</li>
        <li>Attempt to reverse engineer, copy, or disrupt the service.</li>
        <li>Upload or transmit content that violates third-party rights.</li>
      </ul>

      <div className={s.title}>6) Third-Party Services</div>
      <p>
        The Application may rely on third-party services (including analytics,
        crash reporting, and subscription tooling). Their terms and privacy
        policies apply in addition to these Terms.
      </p>

      <div className={s.title}>7) Intellectual Property</div>
      <p>
        All rights in the Application, including software, branding, and
        content elements, remain the property of the Service Provider or their
        licensors. No ownership rights are transferred to you.
      </p>

      <div className={s.title}>8) Disclaimer of Warranties</div>
      <p>
        The Application is provided without warranties of any kind, express or
        implied, including fitness for a particular purpose, availability, or
        error-free operation.
      </p>

      <div className={s.title}>9) Limitation of Liability</div>
      <p>
        To the maximum extent permitted by law, the Service Provider is not
        liable for indirect, incidental, consequential, or special damages
        arising from use of, or inability to use, the Application.
      </p>

      <div className={s.title}>10) Termination</div>
      <p>
        You may stop using the Application at any time by uninstalling it. The
        Service Provider may limit or terminate access where required by law,
        policy, or security considerations.
      </p>

      <div className={s.title}>11) Changes to These Terms</div>
      <p>
        The Service Provider may update these Terms from time to time. Updated
        terms are effective when published in the Application or on related
        policy pages.
      </p>

      <div className={s.title}>12) Contact</div>
      <p>
        For legal or terms-related questions, contact:
        account@goodwavelab.com.
      </p>
    </TermOfUseLayout>
  );
}
